export default __webpack_public_path__ + "eaa2348075ab718bb63be925a9c66625.svg";